import { useEffect } from 'react'
import { Button, Form, Icon, Input } from 'mk-pc'
import { useMessage } from '@mkmp/core'
import { queryNavFunction, updateNavFunction } from '../../service'
import './FunctionList.scss'

interface Props {
  value?: any
}

/**
 * 导航功能点
 * @returns
 */
export const FunctionList: React.FC<Props> = (props) => {
  const { messageApi } = useMessage()
  const { value } = props

  const [form] = Form.useForm()

  useEffect(() => {
    if (!value || !value.id) return

    fetchFunction()
  }, [value])

  /**
   * 加载详情
   */
  const fetchFunction = async () => {
    if (!value || !value.id) return
    const result = await queryNavFunction(value.id)
    form.setFieldValue('functions', result)
  }

  /**
   * 提交数据
   */
  const handleSubmit = async () => {
    const { functions } = await form.validateFields()
    await updateNavFunction({ navId: value.id, navFunctions: functions })
    messageApi.open({
      type: 'success',
      content: '操作权限保存成功',
      duration: 2
    })
    fetchFunction()
  }

  return (
    <section className="functionlist">
      <Form form={form} name="functionlist-form" autoComplete="off">
        <Form.List name="functions">
          {(fields: any, { add, remove }: any) => (
            <>
              <header className="functionlist-form__header">
                <Button onClick={() => add()}>新增</Button>
                <Button type="primary" onClick={handleSubmit}>
                  保存
                </Button>
              </header>
              {fields.map(({ key, name, ...restField }: any) => (
                <div key={key} className="functionlist-form__item">
                  <Form.Item {...restField} label="权限码" name={[name, 'functionCode']} rules={[{ required: true, message: '请输入权限码' }]}>
                    <Input placeholder="输入权限码" />
                  </Form.Item>
                  <Form.Item {...restField} label="权限名称" name={[name, 'functionName']} rules={[{ required: true, message: '请输入权限名称' }]}>
                    <Input placeholder="输入权限名称" />
                  </Form.Item>
                  <Icon name="icon-minus-circle" onClick={() => remove(name)} />
                </div>
              ))}
            </>
          )}
        </Form.List>
      </Form>
    </section>
  )
}
